import React, {Component} from 'react';
import Select from 'react-select';


class PortalSelect extends React.Component {

    constructor(props) {
        super(props);
    }

    renderError() {
        if (this.canShowError()) {
            return (
                <div className={'form-control-feedback error-block'}>
                    {this.props.meta.error}
                </div>
            );
        }
        return null;
    }

    canShowError() {
        if (this.props.isUpdate) {
            return this.props.meta.error
        }
        return this.props.meta.error && this.props.meta.touched;
    }

    applyErrorClass() {
        return this.canShowError() ? 'has-danger' : '';
    }

    render() {
        return (
            <div className={`form-group row ${this.applyErrorClass()}`} id={`div_${this.props.input.name}`}>
                <label className="col-sm-2 col-form-label"><b>{this.props.label}</b></label>
                <div className="col-sm-10">
                    <Select
                        {...this.props}
                        value={this.props.input.value}
                        options={this.props.options}
                        onChange={(value) => this.props.input.onChange(value)}
                        placeholder={this.props.placeholder}
                        clearable={false}
                        simpleValue={true}
                        menuContainerStyle={{'zIndex': 999}}
                        onBlur={() => this.props.input.onBlur(this.props.input.value)}
                    />
                    {this.renderError()}
                </div>
            </div>
        );
    }
}

export default PortalSelect;


// WEBPACK FOOTER //
// ./web/src/components/portal-contact/PortalSelect.jsx